import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { AutoCompleteComponent, ComboBoxComponent, PopupSettings } from '@progress/kendo-angular-dropdowns';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { ControlType } from '@app/cp/shared/enums/ControlTypes';
import { GItem } from '@app/cp/shared/models/GItem';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { CommonParam } from '../../models/CommonParam';

@Component({
    selector: 'location-selector',
    templateUrl: './location-selector.component.html',
    styleUrls: ['./location-selector.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LocationSelectorComponent implements OnInit {
    @ViewChild("searchAC") ac: AutoCompleteComponent;

    @Output() selected: EventEmitter<any> = new EventEmitter<any>();
    @Input() customerId: any;
    @Input() activeOnly: boolean = true;
    //@Input('customerId') public set customerId(customerId: any) {
    //    if (customerId !== this.customerId) {
    //        this.clear();
    //    }
    //    this._customerId = customerId;
    //}
    //get customerId(): any {
    //    return this._customerId;
    //}
    subs: Subscription;
    @Input() minSearchSize: number = 3;

    clear() {
        this.ac.reset();
    }
    data: GItem[];
    constructor(globals: GlobalsService, private svc_data: DQOIService) {

    }
    ngOnInit() {
        CommonFunctions.unsubscribe(this.subs);
        this.subs = this.svc_data.customerId$.subscribe(data => {
            if (data !== this.customerId) {
                this.clear();
                this.customerId = data;
            }

        });
    }
    getParam(search: string) : CommonParam {
        let param: CommonParam = new CommonParam();
        param.search = search;
        param.active = this.activeOnly;
        param.customerId = this.customerId;
        return param;
    }

    filterChange(filter: string) {

        if (filter.toString().length < this.minSearchSize) {
            this.data = [];
            return;
        }
//        if (CommonFunctions.hasValue(this.customerId)) {
        this.setLoading(true);
        let param: CommonParam = this.getParam(filter);
            this.svc_data.searchCustomerLocations(param).subscribe((data: GItem[]) => {
                this.data = data;
                this.setLoading(false);
            });
//        }
    }
    setLoading(loading: boolean) {
            this.ac.loading = loading;
    }
    location: string;
    valueChange(value: any) {
        var arr: string[] = value.split("::");
        this.location = arr[0].trim();
        var id = arr[1];
        this.svc_data.locationIdChanged(id);
        this.selected.emit(id);
    }
}
